import React, { useState, useEffect } from "react";
import _ from "lodash";
import ListingTable from "../ListingTable";
import { useSelector, useDispatch } from "react-redux";
import { getCustomerSuggestion } from "../../actions/customerSuggestion";
import { checkNameEmail } from "../../common";
import DetailModal from "./DetailModal";
import { cloneDeep } from "lodash";
import { useHistory, useParams } from "react-router";
import { Loader } from "../Utils/Loader";
import moment from "moment";

const CustomerSuggestion = ({ searchText, archieveData }) => {
  const dispath = useDispatch();
  const history = useHistory();
  const params = useParams();

  const [isFetching, setIsFetching] = useState(true);
  const [customerSuggestionList, setcustomerSuggestionList] = useState([]);
  const [isSuggestionModalOpen, setIsSuggestionModalOpen] = useState(false);
  const [suggestionText, setSuggestionText] = useState("");
  const [selectedRow, setSelectedRow] = useState({});
  const getAllReportData = useSelector((state) => state.reportReducers);

  const [pageData, setPageData] = useState({
    page: 1,
    pageCount: "",
    searchText,
    columnname: "date_and_time",
    order: "desc",
    tab:
      params.type === "customerfacilityfault"
        ? "cff"
        : params.type === "customertrainfault"
        ? "ctf"
        : "cs",
    is_archive: archieveData.is_archive,
    reportId: archieveData.reportId,
    selectedSortingColumn: "Date & Time",
  });

  const customerSuggestion = useSelector(
    (state) => state.CustomerSuggestionReduer.CustomerSuggestions
  );

  useEffect(() => {
    if (customerSuggestion && Array.isArray(customerSuggestion.pageData)) {
      let customerSuggestionTemp = JSON.parse(
        JSON.stringify(customerSuggestion.pageData)
      );
      setIsFetching(false);
      setcustomerSuggestionList(customerSuggestionTemp);
      if (customerSuggestion.pageCount) {
        setPageData({ ...pageData, pageCount: customerSuggestion.pageCount });
      }
    }
  }, [customerSuggestion]);

  useEffect(() => {
    let pageDataTemp = cloneDeep(pageData);
    pageDataTemp.searchText = searchText;
    pageDataTemp.is_archive = archieveData.is_archive;
    pageDataTemp.reportId = archieveData.reportId;
    pageDataTemp.page = 1;

    // if (pageData.is_archive === pageDataTemp.is_archive) {
    //     pageDataTemp.reportId = selectedReportID;
    // }
    // else {
    //     pageDataTemp.reportId = '';
    // }
    setPageData(pageDataTemp);
    if (
      Object.keys(getAllReportData.allReports).length > 0 &&
      getAllReportData.allReports.pageData.some(
        (el) => el.id === archieveData.reportId
      ) &&
      getAllReportData.allReports.tab == "CS"
    ) {
      setIsFetching(true);
      dispath(getCustomerSuggestion(pageDataTemp));
    }

    // if (archieveData.reportId) {
    //   setIsFetching(true);
    //   dispath(getCustomerSuggestion(pageDataTemp));
    //   setIsFetching(false);
    // }
  }, [searchText, archieveData.reportId, archieveData.is_archive]);

  const detailTextHandler = (detailsText) => {
    setSuggestionText(detailsText);
    setIsSuggestionModalOpen(true);
  };

  const getPageData = (pageData) => {
    let pageDataTemp = cloneDeep(pageData);
    pageDataTemp = cloneDeep(pageData);
    setIsFetching(true);
    setPageData(pageDataTemp);
    dispath(getCustomerSuggestion(pageDataTemp));
  };

  const getColumns = () => {
    return [
      {
        Header: "Name",
        accessor: "Name",
      },
      {
        Header: "Date & Time",
        Cell: (cellProps) => (
          <span>
            {cellProps.row.original["Date & Time"]
              ? moment(cellProps.row.original["Date & Time"]).format(
                  "DD-MM-YYYY HH:mm"
                )
              : ""}
          </span>
        ),
      },
      {
        Header: "Email address",
        accessor: "Email",
      },
      {
        Header: "Mobile number",
        Cell: (cellProps) => (
          <span>
            {cellProps.row.original["Mobile Number"]
              ? checkNameEmail(cellProps.row.original, "Mobile Number")
              : ""}
          </span>
        ),
      },
      {
        Header: "Suggestion",
        Cell: (cellProps) => {
          let detailString = cellProps.row.original.Suggestion;
          return (
            <span
              className="text-primary"
              onClick={() => detailTextHandler(detailString)}
            >
              {detailString &&
                detailString.slice(0, 25) +
                  (detailString.length > 25 ? "..." : "")}
            </span>
          );
        },
      },
    ];
  };

  const onShowDetails = (row) => {
    setSelectedRow(row);
    let id =
      !_.isEmpty(row) && !_.isEmpty(row.original) ? row.original.id : undefined;
    if (id && archieveData.reportId) {
      history.push({
        pathname: `/FaultReporter/admin/suggestions/${id}/${archieveData.reportId}`,
        details: row.original,
      });
    } else {
      history.push({
        pathname: `/FaultReporter/admin/suggestions`,
      });
    }
  };

  const editReportHandler = (id) => {
    history.push(
      `/FaultReporter/admin/reports/${params.type}/add/${
        archieveData.is_archive == 0 ? "live" : "archive"
      }/${id}`
    );
  };

  return (
    <div>
      <>
        <div className="main-body-header-section">
          <h2 className="main-body-heading">
            {searchText
              ? "Searched Fault Results"
              : archieveData.reportId
              ? archieveData.selectedReportName
              : "All Suggestions"}
          </h2>
          {!searchText &&
            archieveData.reportId &&
            !(archieveData.selectedReportName === "All Suggestions") && (
              <button
                className="btn btn-primary btn-icon waves-effect waves-circle waves-float"
                onClick={() => editReportHandler(archieveData.reportId)}
              >
                <i className="zmdi zmdi-edit "></i>
              </button>
            )}
        </div>
        <div className="listing-table">
          {isFetching ? (
            <Loader />
          ) : customerSuggestionList.length > 0 ? (
            <ListingTable
              columns={getColumns()}
              data={customerSuggestionList}
              pageData={pageData}
              getPageData={getPageData}
              selectedRow={selectedRow}
              onShowDetails={onShowDetails}
            />
          ) : (
            <div className="fault-history">
              <div className="no-user">
                <i className="zmdi zmdi-block"></i>No faults to display.
              </div>
            </div>
          )}
        </div>
      </>

      {isSuggestionModalOpen && (
        <DetailModal
          modalText={suggestionText}
          isDetailsModalOpen={setIsSuggestionModalOpen}
          modalHeader={"Suggestion"}
        />
      )}
    </div>
  );
};

export default CustomerSuggestion;
